<template lang="pug">
include /@ibkr/lib.common/src/icon/basic
include /@ibkr/lib.common/src/icon/arrow
include /@ibkr/lib.common/src/icon/color
div(class="product-info")
    div(class="iframe-header")
        div(class="iframe-info")
            iframe(
                :src="iframeURL"
                style="border:none",
                width="100%",
                height="100%",
                title="Contract Details",
                id="contractFrame",
            )
</template>

<script>
import api from '../api';
import { mapState, mapActions, mapGetters } from 'vuex';
import tradingChart from '../js/TradingChart.js';
import SearchProducts from './SearchProducts.vue';

export default {
    name: 'ContractDetails',
    components: {
        SearchProducts,
    },
    data() {
        return {
            show: false,
            results: '',
            summary: '',
            ratios: '',
            forecast: '',
            assetName: '',
            listingExchange: '',
            symbol: '',
            conid: this.$route.params.conid,
            productName: '',
            isSummary: true,
            showQuoteDetails: '',
            reloadIframe: false,
            quoteDetailsCookie: '',
            nightlyCookie: '',
            langCookie: '',
            iframeURL: '',
            quoteDetailsCookieValue: '',
            loginURL: '',
        }
    },
    mixins: [tradingChart],
    mounted() {
        // API to get URL for user login page
        api.getLoginURL()
            .then(response => {
                this.loginURL = response.domain;
                console.debug("Login URl: ", this.loginURL);
            })
        
        window.addEventListener('message', (event) => {
            if((event.data === 'login' || event.data === 'signUp') && event.origin === "https://www.interactivebrokers.com"){
                if(event.data  === 'login'){
                    window.open(this.loginURL + "/sso/Login","_blank");
                } else if(event.data === 'signUp') {
                    window.open(this.selectedTrackingUrl,"_blank");
                }
            }
        }, false);
        this.getSummary(this.conid);
    },
    watch: {
        '$route.params.conid'(to, from) {
            this.results = '',
            this.summary = '';
            this.ratios = '';
            this.forecast = '';
            this.assetName = '';
            this.listingExchange = '';
            this.productName = '';
            this.isSummary = true;
            this.iframeURL = '';
            this.getSummary(to, this.$route.params.type);
        },
        '$route.params.type'(to, from) {results: '',
            this.summary = '';
            this.ratios = '';
            this.forecast = '';
            this.assetName = '';
            this.listingExchange = '';
            this.productName = '';
            this.isSummary = true;
            this.iframeURL = '';
            this.getSummary(this.$route.params.conid, to);
        }
    },
    methods: {
        open(conid, type) {
            let secType = this.$route.params.type.toUpperCase();
            this.iframeURL = '';
            this.langCookie = document.cookie.split('IB_LANG=').pop().split(';').shift();
            this.quoteDetailsCookieValue = document.cookie.split('IB_QD=');
            this.quoteDetailsCookie = document.cookie.split('IB_QD=').pop().split(';').shift();

            // IB_NIGHTLY cookie is set manually. When the cookie value is 1, nightly iframe is loaded
            this.nightlyCookie = document.cookie.split('IB_NIGHTLY=').pop().split(';').shift();

            if(this.langCookie != "en"){
                this.langCookie = "en";
            }

            // Update langugage value for Chinese and Japanese
            switch(this.langCookie) {
                case 'cn':
                    this.langCookie = "zh_CN";
                    break;
                case 'jp':
                    this.langCookie = "ja";
                    break;
            }


            console.debug("IB_LANG:", this.langCookie);
            
            if(this.nightlyCookie === '1' || window.location.href.search(/test.php/) != -1){
                this.iframeURL = `https://www.interactivebrokers.com/free.to.air/nightly/web1/index.html#/?conid=${this.$route.params.conid}&sectype=${secType}&lang=${this.langCookie}&ib_entity=${this.selectedDomain}&noPad=1`;
            } else {
                this.iframeURL = `https://www.interactivebrokers.com/free.to.air/web1/index.html#/?conid=${this.$route.params.conid}&sectype=${secType}&lang=${this.langCookie}&ib_entity=${this.selectedDomain}&noPad=1`;
            }
            console.debug("Iframe URL: ",this.iframeURL);
        },
        getSummary(conid, type) {
            this.open(conid, type);
        },
        close() {
            this.show = false;
            this.summary = '';
            this.ratios = '';
            this.forecast = '';
            this.assetName = '';
            this.listingExchange = '';
            this.isSummary = true;
            this.resetValues();
        },
        openDisclosure() {
            window.open("https://ibkr.info/article/2966","_blank", "width=1000px, height=700px");
        },
        ...mapActions(['setProductResults','setProducts', 'setTypesList'])
    },
    computed: {
        ...mapGetters(['selectedTrackingUrl', 'selectedDomain']),
        ...mapState(['listedResults', 'summaryy', 'forecst', 'marketdata', 'pageNumber', 'numShow'])
    }
}
</script>

<style lang="less">
.results {
    padding: 20px;
}
span {
    .up {
        position: relative;
        right: -8px;
        top: -6px;
        &.active-sort {
            color: #000;
        }
    }
    .down {
        position: relative;
        left: -5px;
        top: 4px;
        &.active-sort {
            color: #000;
        }
    }
}
.description {
    color: #F99999;
    cursor: pointer;
}
.external-icon {
    svg {
        position: relative;
        top: 0.8px;
        left: 6px;
        width: 1em;
        height: 1em;
    }
}
.icon-close {
    position: absolute;
    right: 10px;
    top: 10px;
    svg {
        width: 2rem;
    }
}
.contract-details {
    width: 100%;
    //border-top: 1px solid #d4d4d4;
    margin-top: 10px;
}
.quote-details {
    // padding: 0px 10px 10px;
    color: black;
}
.quote-details-header {
    border-bottom: 1px solid #d4d4d4;
    display: flex;
}
.quote-askbid {
    display: flex;
    padding-left: 28px;
    padding-top: 24px;
}
.ask-bid {
    font-size: 16px;
}
.ask-bid-data {
    padding-left: 15px;
}
.quote-data {
    margin-left: 8px;
    font-size: 22px;
}
.sumary {
    text-align: left;
    color: black;
    padding: 16px 0px;
    border-bottom: 1px solid #d4d4d4;
}
.fundamentals-details {
    align-self: stretch;
}

.fundamentals-details li {
    list-style: none;
}
.fund-detail {
    align-self: stretch;
}
.fund-detail li {
    list-style: none;
}
.marketadata-col {
    border-right: 1px solid #d4d4d4;
}
.md-col {
    align-self: stretch;
    padding: 6px;
}
.values {
    float: right;
    font-weight: bold;
}
.comp-dialog {
    border-top: 5px solid #d91222
}
@media (max-width:768px) {
    .contract-info {
        display: flex;
        flex-direction: column;
        border-bottom: 1px solid #d4d4d4;
    }
    .product-name {
        width: 100%;
        padding-right: 20px;
    }
    .declaration {
        width: 100%;
        text-align: left;
    }
    .fundamentals {
        color:black;
        flex-direction: column;
        padding-top: 24px;
    }
    .fundamentals-details {
        padding-left: 16px;
    }
    .fund-detail {
        padding-left: 16px;
    }
}
@media (min-width:768px) {
    .contract-info {
        display: flex;
        flex-direction: row;
        border-bottom: 1px solid #d4d4d4;
    }
    .product-name {
        width: 40%;
        box-sizing: border-box;
        padding-right: 20px;
    }
    .declaration {
        width: 60%;
        text-align: left;
    }
    .fundamentals {
        color:black;
        flex-direction: row;
        padding-top: 24px;
    }
    .fundamentals-details {
        border-right: 1px solid #d4d4d4;
        margin-right: 20px;
    }
}
.disclose-link {
    color: blue;
    cursor: pointer;
}
.alignment {
    position: relative;
    left: 50%;//
}
.warnings {
    display: block;
    margin: auto;
    text-align: center;
    svg {
        width: 5%;
        height: 5%;
    }
}
.warning-message {
    padding-top: 16px;
    display: block;
    margin: auto;
    text-align: center;
}
.iframe-header {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding-top: 16px;
}
.iframe-info {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
}
.product-info {
    width: 100%;
    height: 1800px;
}
@media (min-width: 851px) and (max-width: 1100px) {
    .product-info {
        height: 2350px;
    }
}
@media (min-width: 551px) and (max-width: 850px) {
    .product-info {
        height: 3100px;
    }
}
@media (min-width: 451px) and (max-width: 550px) {
    .product-info {
        height: 3350px;
    }
}
@media (min-width: 400px) and (max-width: 450px) {
    .product-info {
        height: 3600px;
    }
}
@media (min-width: 351px) and (max-width: 399px) {
    .product-info {
        height: 4100px;
    }
}
@media (max-width: 350px) {
    .product-info {
        height: 4200px;
    }
}
</style>

